// Updated Laxmi Promise Component with Correct API + Improved Layout
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
import Button from "../../../../component/Button/Button";
import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";
import Imageurldata from "../../../../Imageurldata";
import config from "../../../../config/config";

const LaxmiPromise = () => {
  const [loading, setLoading] = useState(false);

  const [title1, setTitle1] = useState("");
  const [subtitle1, setSubtitle1] = useState("");
  const [title2, setTitle2] = useState("");
  const [subtitle2, setSubtitle2] = useState("");
  const [title3, setTitle3] = useState("");
  const [subtitle3, setSubtitle3] = useState("");

  const [img, setImg] = useState(null);
  const [imgPreview, setImgPreview] = useState("");
  const [imgNew, setImgNew] = useState(false);

  const [err1, setErr1] = useState("");
  const [err2, setErr2] = useState("");
  const [err3, setErr3] = useState("");
  const [err4, setErr4] = useState("");
  const [err5, setErr5] = useState("");
  const [err6, setErr6] = useState("");
  const [errImg, setErrImg] = useState("");

  const [recordId, setRecordId] = useState("");
  const [toastlist, setToastList] = useState([]);

  const allowedTypes = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/jpg",
    "image/svg+xml", 
  ];

  const showToast = (type, msg) => {
    const id = Date.now();
    const toastProperties = {
      id,
      title: type === "success" ? "Success" : "Error",
      description: msg,
      backgroundColor: type === "success" ? "#329F33" : "red",
      icon: type === "success" ? check : close,
    };
    setToastList((prev) => [...prev, toastProperties]);
  };

  const validateImage = (file) => {
    if (!allowedTypes.includes(file.type)) {
      return "*Only JPG, PNG, WEBP images are allowed.";
    }
    return "";
  };

  // FETCH API (Corrected)
  const fetchSection = () => {
    setLoading(true);
    axios
      .get(`${config.api_url}ourstory/laxmipromise`)
      .then((res) => {
        const data = res.data[0];
        if (data) {
          setRecordId(data._id);
          setTitle1(data.title1 || "");
          setSubtitle1(data.subtitle1 || "");
          setTitle2(data.title2 || "");
          setSubtitle2(data.subtitle2 || "");
          setTitle3(data.title3 || "");
          setSubtitle3(data.subtitle3 || "");

          if (data.image) {
            const full = Imageurldata + data.image;
            setImgPreview(full);
          }
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchSection();
  }, []);

  // SUBMIT API (Corrected)
  const submit = () => {
    let valid = true;

    if (!title1) {
      setErr1("*Required");
      valid = false;
    } else setErr1("");
    if (!subtitle1) {
      setErr2("*Required");
      valid = false;
    } else setErr2("");
    if (!title2) {
      setErr3("*Required");
      valid = false;
    } else setErr3("");
    if (!subtitle2) {
      setErr4("*Required");
      valid = false;
    } else setErr4("");
    if (!title3) {
      setErr5("*Required");
      valid = false;
    } else setErr5("");
    if (!subtitle3) {
      setErr6("*Required");
      valid = false;
    } else setErr6("");

    if (!recordId && !img) {
      setErrImg("*Please upload image.");
      valid = false;
    }

    if (!valid) return;

    const formData = new FormData();
    formData.append("title1", title1);
    formData.append("subtitle1", subtitle1);
    formData.append("title2", title2);
    formData.append("subtitle2", subtitle2);
    formData.append("title3", title3);
    formData.append("subtitle3", subtitle3);

    if (imgNew) formData.append("image", img);
    if (recordId) formData.append("id", recordId);

    const url = recordId
      ? `${config.api_url}ourstory/laxmipromise/update`
      : `${config.api_url}ourstory/laxmipromise/new`;

    setLoading(true);

    axios
      .post(url, formData)
      .then(() => {
        showToast(
          "success",
          recordId ? "Updated Successfully" : "Added Successfully"
        );
        fetchSection();
        setImgNew(false);
        setLoading(false);
      })
      .catch((err) => {
        const msg = err.response?.data || "Error saving";
        showToast("error", msg);
        setLoading(false);
      });
  };

  return (
    <>
      <h1>Laxmi Promise Section</h1>

      <Row className="adminhomeaboutSec1">
        {/* Title 1 */}
        <Col lg={3} className="column">
          <div className="title">Title 1</div>
          <div className="text-muted">Recommended: up to 20 characters</div>
        </Col>
        <Col lg={9} className="column">
          <input
            type="text"
            className="form-control"
            value={title1}
            onChange={(e) => setTitle1(e.target.value)}
          />
          <div className="err">{err1}</div>
        </Col>

        {/* Subtitle 1 */}
        <Col lg={3} className="column">
          <div className="title">Subtitle 1</div>
          <div className="text-muted">Recommended: up to 40 characters</div>
        </Col>
        <Col lg={9} className="column">
          <textarea
            rows={3}
            className="form-control"
            value={subtitle1}
            onChange={(e) => setSubtitle1(e.target.value)}
          />
          <div className="err">{err2}</div>
        </Col>

        {/* Title 2 */}
        <Col lg={3} className="column">
          <div className="title">Title 2</div>
          <div className="text-muted">Recommended: up to 20 characters</div>
        </Col>
        <Col lg={9} className="column">
          <input
            type="text"
            className="form-control"
            value={title2}
            onChange={(e) => setTitle2(e.target.value)}
          />
          <div className="err">{err3}</div>
        </Col>

        {/* Subtitle 2 */}
        <Col lg={3} className="column">
          <div className="title">Subtitle 2</div>
          <div className="text-muted">Recommended: up to 40 characters</div>
        </Col>
        <Col lg={9} className="column">
          <textarea
            rows={3}
            className="form-control"
            value={subtitle2}
            onChange={(e) => setSubtitle2(e.target.value)}
          />
          <div className="err">{err4}</div>
        </Col>

        {/* Title 3 */}
        <Col lg={3} className="column">
          <div className="title">Title 3</div>
          <div className="text-muted">Recommended: up to 20 characters</div>
        </Col>
        <Col lg={9} className="column">
          <input
            type="text"
            className="form-control"
            value={title3}
            onChange={(e) => setTitle3(e.target.value)}
          />
          <div className="err">{err5}</div>
        </Col>

        {/* Subtitle 3 */}
        <Col lg={3} className="column">
          <div className="title">Subtitle 3</div>
          <div className="text-muted">Recommended: up to 40 characters</div>
        </Col>
        <Col lg={9} className="column">
          <textarea
            rows={3}
            className="form-control"
            value={subtitle3}
            onChange={(e) => setSubtitle3(e.target.value)}
          />
          <div className="err">{err6}</div>
        </Col>

        {/* IMAGE */}
        <Col lg={3} className="column">
          <div className="title">Main Image</div>
          <div className="text-muted">Recommended size: 294 × 294 px</div>
          <div className="desc">SVG format supported</div>
        </Col>

        <Col lg={9} className="column">
          <input
            type="file"
            id="laxmiImg"
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0];
              if (!file) return;

              const error = validateImage(file);
              if (error) {
                setErrImg(error);
                return;
              }

              setErrImg("");
              setImg(file);
              setImgPreview(URL.createObjectURL(file));
              setImgNew(true);
            }}
            style={{ display: "none" }}
          />

          <label htmlFor="laxmiImg" className="d-f mt-2" id="file-drag">
            <img src={upload} className="img-fluid" />
            <div className="chooseTxt">Choose File</div>
          </label>

          {/* <div className="d-f jc-sb">
            <div className="fileTxt">File Format : JPG / PNG / Svg</div>
          </div> */}

          <div className="err">{errImg}</div>

          {imgPreview && (
            <img
              src={imgPreview}
              style={{
                width: "120px",
                height: "120px",
                marginTop: "10px",
                borderRadius: "6px",
                objectFit: "cover",
              }}
            />
          )}
        </Col>

        {/* BUTTON */}
        <Col className="column d-f j-c a-c mt-4">
          <Button onClick={submit} title={recordId ? "UPDATE" : "ADD"} />
        </Col>
      </Row>

      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default LaxmiPromise;
